import { css } from '@emotion/react';
import t from 'react-translate';
import NvCheckbox from 'shared/components/inputs/nv-checkbox';
import { heatwave } from 'athena/styles/colors';
import { CellProps } from './types';


export const selectedCheckboxStyles = css`
  input:checked + label:before,
  input.indeterminate + label:before {
    background-color: ${heatwave};
    border-color: ${heatwave};
    color: white;
  }
`;

const CheckboxCell = ({ cell, className }: CellProps) => {
  const application = cell.getValue();
  const {
    table: {
      options: { meta },
    },
  } = cell.getContext();
  const {
    isApplicationSelected,
    setSelectedApplications,
  } = meta ?? {};

  const handleCheckboxChange = () => {
    setSelectedApplications?.((prevSelected) => (
      prevSelected.some(({ id }) => id === application.id)
        ? prevSelected.filter(({ id }) => id !== application.id)
        : [...prevSelected, application]
    ));
  };

  return (
    <div className={className}>
      <NvCheckbox
        css={selectedCheckboxStyles}
        name={`select-application-${application.id}`}
        label=''
        ariaLabel={t.MENTORING_PROGRAMS.RECRUITMENT.ARIA_LABEL.SELECT_APPLICATION(
          t.USERS.FULL_NAME(application.user.firstName, application.user.lastName),
        )}
        checked={isApplicationSelected?.(application.id) ?? false}
        onChange={handleCheckboxChange}
      />
    </div>
  );
};

export default CheckboxCell;
